import { Box } from '@spark-web/box';
import { Text } from '@spark-web/text';
import { FC } from 'react';

import { Promotion } from '~/gql/graphql';

import { FilterChip } from './filter-chip';

type FiltersBarProps = {
  activeFilters?: {
    promotionCodes?: Array<string>;
  };
  promotions?: Array<Pick<Promotion, 'title' | 'code'>>;
  onRemovePromotion?: (promotionCode: string) => void;
};

const FiltersBar: FC<FiltersBarProps> = ({ activeFilters, promotions: allPromotions, onRemovePromotion }) => {
  const { promotionCodes: selectedPromotionCodes } = activeFilters || {};

  const activePromotions = allPromotions?.filter((promo) => selectedPromotionCodes?.includes(promo.code)) || [];

  const handleRemovePromotion = (promotionCode: string) => {
    onRemovePromotion?.(promotionCode);
  };

  return (
    <Box display="flex" flexWrap="wrap" alignItems="start" gap="medium">
      {activePromotions?.map((promo) => (
        <FilterChip key={promo.code} onRemove={() => handleRemovePromotion(promo.code)}>
          <Text size="xsmall">Promo: {promo.title}</Text>
        </FilterChip>
      ))}
    </Box>
  );
};

export { FiltersBar };
